/**
 * Initializes the CDK
 */
export const initCDK = () => {
  const cdkElement = document.createElement('astral-cdk');
  document.documentElement.appendChild(cdkElement);
};
